'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _oidcClient = require('oidc-client');

var _oidcClient2 = _interopRequireDefault(_oidcClient);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
    function AuthService($log, $q, $location, $exceptionHandler, settings, Analytics) {
        _classCallCheck(this, AuthService);

        this.$log = $log;
        this.$q = $q;
        this.$location = $location;
        this.$exceptionHandler = $exceptionHandler;
        this._userLoadedEvent = new Event('User loaded');
        this._userUnloadedEvent = new Event('User unloaded');
        this._userSignedOutEvent = new Event('User signed out');
        this._initialized = false;
        this._userManager = new _oidcClient2.default.UserManager(settings);
        this.Analytics = Analytics;
        this._wireUserManagerEvents();
    }

    AuthService.prototype.addUserLoadedEvent = function addUserLoadedEvent(callback) {
        var _this = this;

        this._userLoadedEvent.addHandler(callback);
        return function () {
            return _this._userLoadedEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserLoaded(callback);
        //this._callbacks.push(callback);
        //return () => this._callbacks.splice(this._callbacks.findIndex(callback),1);
    };

    AuthService.prototype.addUserUnloadedEvent = function addUserUnloadedEvent(callback) {
        var _this2 = this;

        this._userUnloadedEvent.addHandler(callback);
        return function () {
            return _this2._userUnloadedEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserLoaded(callback);
        //this._callbacks.push(callback);
        //return () => this._callbacks.splice(this._callbacks.findIndex(callback),1);
    };

    AuthService.prototype.addUserSignedOut = function addUserSignedOut(callback) {
        var _this3 = this;

        this._userSignedOutEvent.addHandler(callback);
        return function () {
            return _this3._userSignedOutEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserSignedOut(callback);
    };

    AuthService.prototype.hasClaim = function hasClaim(claim, value) {
        var _this4 = this;

        if (!claim) {
            return true;
        }
        if (!this.user) {
            return false;
        }
        if (claim instanceof Array) {
            return claim.every(function (c) {
                return !!_this4.user[c] && _this4._hasClaimValue(claim, value);
            });
        }
        return !!this.user[claim] && this._hasClaimValue(claim, value);
    };

    AuthService.prototype._hasClaimValue = function _hasClaimValue(claim, value) {
        if (value === undefined) {
            return true;
        }
        if (this.user[claim] instanceof Array) {
            return this.user[claim].some(function (c) {
                return c === (value ? '' + value : value);
            });
        }
        return this.user[claim] === (value ? '' + value : value);
    };

    AuthService.prototype.hasClaimAsync = function hasClaimAsync(claim) {
        var _this5 = this;

        if (this._initialized === false) {
            return this._initPromise.then(function () {
                return _this5.hasClaim(claim);
            }, function () {
                return _this5.hasClaim(claim);
            });
        }
        return this.hasClaim(claim);
    };

    AuthService.prototype.init = function init() {
        var _this6 = this;

        this._initialized = false;
        this._initPromise = this._userManager.getUser().then(function (user) {
            _this6._setUser(user);
            _this6._initialized = true;
            return user ? _this6.$q.resolve() : _this6.$q.reject();
        }, function () {
            _this6._initialized = true;
        });
        return this._initPromise;
    };

    AuthService.prototype.signIn = function signIn(requestedUrl, acrValues, language) {
        var _this7 = this;

        if (!acrValues) {
            if (this.isAuthenticated) {
                return this.$q.resolve();
            }
            if (this._initialized === false) {
                return this._initPromise.catch(function () {
                    return _this7._signIn(requestedUrl, acrValues, language);
                });
            }
        }
        return this._signIn(requestedUrl, acrValues, language);
    };

    AuthService.prototype.signOut = function signOut() {
        this._setUser();
        this.$log.debug('Security - sign out');
        return this._userManager.signoutRedirect();
    };

    AuthService.prototype.clearGALocalStorage = function clearGALocalStorage() {
        window.localStorage.removeItem('FlexMail');
        window.localStorage.removeItem('GAFlexTrack');
        window.localStorage.removeItem('GAFlexAlreadyLoginTrack');
        window.localStorage.removeItem('GAUserNotLoggedInTracked');
        window.localStorage.removeItem('GAUserNotLoggedInTrack');
        window.localStorage.removeItem('GAFlexNewLoginTrack');
    };

    AuthService.prototype._accessTokenExpired = function _accessTokenExpired() {
        var _this8 = this;

        this.$log.debug('Access token expired');
        // Must we do this?
        this._userManager.signinSilent().then(function (user) {
            _this8.$log.debug('Relogin success ', user);
            _this8._setUser(user);
        }, function (err) {
            _this8.$log.debug('Relogin failed: ', err);
            _this8._setUser();
        });
    };

    AuthService.prototype._accessTokenExpiring = function _accessTokenExpiring() {
        this.$log.debug('Access token expiring');
    };

    AuthService.prototype._formatAcrValues = function _formatAcrValues(acrValues) {
        if (!acrValues) {
            return;
        }

        var acr_values = this._userManager.settings.acr_values || '';
        for (var key in acrValues) {
            if (acrValues.hasOwnProperty(key)) {
                acr_values += key + ':' + acrValues[key] + ' ';
            }
        }
        return acr_values.trim();
    };

    AuthService.prototype._setUser = function _setUser(value) {
        this._user = value;

        if (value) {
            this._userLoadedEvent.raise(value);
            //this._callbacks.forEach(callback => callback(value));

            // track is the user came from flexmail
            if (this.$location.search().track === 'true') {
                window.localStorage.setItem('FlexMail', true);
            }

            // GA track user entered page and logged in
            if (window.localStorage.getItem('GAUserNotLoggedInTrack') === 'true' && !window.localStorage.getItem('GAUserNotLoggedInTracked')) {
                this.Analytics.trackEvent('GAUserLoggedIn', 'GAUserLoggedIn', 'GAUserLoggedIn');
                window.localStorage.setItem('GAUserNotLoggedInTracked', true);
            }

            // GA if the user clicked a flexmail link, log it once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexTrack')) {
                window.localStorage.setItem('GAFlexTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked');
            }

            // GA if the user that clicked a flexmail link, and is already logged in, log it. Only log this once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexAlreadyLoginTrack') && window.localStorage.getItem('GAFlexTrack') && !window.sessionStorage.getItem('GAFlexNewLoginTrack')) {
                window.localStorage.setItem('GAFlexAlreadyLoginTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailUserAlreadyLoggedIn', 'GATrackFlexmailUserAlreadyLoggedIn', 'GATrackFlexmailUserAlreadyLoggedIn');
            }
        } else {
            this._userUnloadedEvent.raise(value);
        }
    };

    AuthService.prototype._signIn = function _signIn(requestedUrl, acrValues, language) {
        var _this9 = this;

        this.$log.debug('Security - sign in');

        // if(window.localStorage.getItem('lastLoginGA')) {
        //     var blw = moment(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff(moment(), 'days');
        // }

        // //first time log in
        // if(!window.localStorage.getItem('lastLoginGA')) {
        //     window.localStorage.setItem('lastLoginGA', moment().format('DD-MM-YYYY'));
        //     // track is the user came from flexmail
        // } else if (moment(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff(moment(), 'days') > 0 ) {
        //     blw;
        // }

        if (this.$location.search().track === 'true') {
            window.localStorage.setItem('FlexMail', true);
        }

        //if the last time the user logged in is greater than a day
        if ((0, _moment2.default)(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff((0, _moment2.default)(), 'days') > 0 || !window.localStorage.getItem('lastLoginGA')) {

            //clear the GA values in the local storage
            this.clearGALocalStorage();

            //set a new last logged in value in the local storage
            window.localStorage.setItem('lastLoginGA', (0, _moment2.default)().format('DD-MM-YYYY'));

            // GA track user entered page and not logged in, only log this once
            if (!window.localStorage.getItem('GAUserNotLoggedInTrack')) {
                window.localStorage.setItem('GAUserNotLoggedInTrack', true);
                this.Analytics.trackEvent('GAUserNotLoggedIn', 'GAUserNotLoggedIn', 'GAUserNotLoggedIn');
            }

            // GA if the user clicked a flexmail link, log it once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexTrack')) {
                window.localStorage.setItem('GAFlexTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked');
            }

            // GA if the user that clicked a flexmail link and had to log in, log it. Only log this once
            if (window.localStorage.getItem('FlexMail') && window.localStorage.getItem('GAFlexTrack') && !window.localStorage.getItem('GAFlexNewLoginTrack')) {
                window.localStorage.setItem('GAFlexNewLoginTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailUserLoggedIn', 'GATrackFlexmailUserLoggedIn', 'GATrackFlexmailUserLoggedIn');
            }

            if (this.isAuthenticated && !acrValues) {
                // If the user is allready authenticated we can signIn
                // without bothering the user.
                // Also the history doesn't get polluted with an extra call to sso.
                return this.$q.when(this._userManager.signinSilent()).then(function () {
                    if (requestedUrl) {
                        _this9.$location.url(requestedUrl);
                        //window.location.assign(requestedUrl);
                    }
                }, function (error) {
                    // If signinSilent fails, log it and log out the user
                    _this9.$exceptionHandler(error);
                    _this9.$log.debug('SigninSilent error ' + error);
                    _this9.signOut();
                });
            }
        }

        window.sessionStorage.setItem('redirectUrl', requestedUrl);

        return this._userManager.signinRedirect({
            acr_values: this._formatAcrValues(acrValues),
            ui_locales: language
        }).then(function () {
            return _this9.$q.reject();
        });
    };

    AuthService.prototype._silentRenewError = function _silentRenewError(e) {
        this.$log.debug('Silent renew error');
        // If silentRenew fails, log it and log out the user
        this.$exceptionHandler(e);
        this.signOut();
    };

    AuthService.prototype._userLoaded = function _userLoaded(user) {
        this._setUser(user);
        this.$log.debug('user loaded: ', user);
    };

    AuthService.prototype._userSignedOut = function _userSignedOut() {
        var _this10 = this;

        var user = Object.assign({}, this._user);
        this._setUser();
        this.$log.debug('User signed out');
        setTimeout(function () {
            return _this10._userSignedOutEvent.raise(user);
        });
    };

    AuthService.prototype._userUnloaded = function _userUnloaded() {
        this._setUser();
        this.$log.debug('user unloaded');
    };

    AuthService.prototype._wireUserManagerEvents = function _wireUserManagerEvents() {
        var _this11 = this;

        this._userManager.events.addAccessTokenExpiring(function () {
            return _this11._accessTokenExpiring();
        });
        this._userManager.events.addAccessTokenExpired(function () {
            return _this11._accessTokenExpired();
        });
        this._userManager.events.addSilentRenewError(function (e) {
            return _this11._silentRenewError(e);
        });
        this._userManager.events.addUserLoaded(function (user) {
            return _this11._userLoaded(user);
        });
        this._userManager.events.addUserSignedOut(function () {
            return _this11._userSignedOut();
        });
        this._userManager.events.addUserUnloaded(function () {
            return _this11._userUnloaded();
        });
    };

    _createClass(AuthService, [{
        key: 'isAuthenticated',
        get: function get() {
            return !!this.user;
        }
    }, {
        key: 'isFebelcoCustomer',
        get: function get() {
            return this.user ? this.user.IsFebelcoCustomer === 'True' : false;
        }
    }, {
        key: 'isBuyer',
        get: function get() {
            return this.user ? this.user.IsBuyer === 'IsBuyer' : false;
        }
    }, {
        key: 'isSeller',
        get: function get() {
            return this.user ? this.user.IsSeller === 'IsSeller' : false;
        }
    }, {
        key: 'defaultWholesalerId',
        get: function get() {
            return this.user.DefaultWholesalerId;
        },
        set: function set(id) {
            this.user.DefaultWholesalerId = id;
        }
    }, {
        key: 'user',
        get: function get() {
            if (this._user) {
                return Object.assign({}, this._user.profile, {
                    customInfo: this._customUserInfo
                });
            }
            return;
        }
    }, {
        key: 'accessToken',
        get: function get() {
            if (this._user) {
                return this._user.access_token;
            }
            return '';
        }
    }, {
        key: 'customUserInfo',
        get: function get() {
            return this._customUserInfo || {};
        },
        set: function set(value) {
            this._customUserInfo = value;
        }
    }]);

    return AuthService;
}();

var Event = function () {
    function Event(name) {
        _classCallCheck(this, Event);

        this._name = name;
        this._callbacks = [];
    }

    Event.prototype.addHandler = function addHandler(cb) {
        this._callbacks.push(cb);
    };

    Event.prototype.removeHandler = function removeHandler(cb) {
        var idx = this._callbacks.findIndex(function (item) {
            return item === cb;
        });
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    };

    Event.prototype.raise = function raise() {
        for (var _iterator = this._callbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var cb = _ref;

            cb.apply(undefined, arguments);
        }
    };

    return Event;
}();

exports.default = AuthService;


//////////////////
// WEBPACK FOOTER
// ./blocks/security/authService.js
// module id = 696
// module chunks = 0